import { Default } from './Default';
import { LegacyDefault } from './LegacyDefault';

export default {
  legacyDefault: LegacyDefault,
  default: Default,
};
